import { Injectable } from '@angular/core';
import { Folder } from '@models/matter';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import * as actions from './folders.actions';

@Injectable({
	providedIn: 'root',
})
export class MatterFoldersDispatch {
	@Dispatch()
	Create = (folder: Folder): actions.Create => new actions.Create(folder);

	@Dispatch()
	BatchCreate = (folders: Folder[]): actions.BatchCreate =>
		new actions.BatchCreate(folders);

	@Dispatch()
	Edit = (folder: Folder): actions.Create => new actions.Create(folder);

	@Dispatch()
	Remove = (folderId: string): actions.Remove => new actions.Remove(folderId);
}
